import translator from "@/translator";
import React, { useState } from "react";
import { Card, Button, Typography, Checkbox, message } from "antd";
import BackButton from "@/note_office/shared/BackButton";
import classNames from "classnames";
import ResultView from "@/note_office/shared/ResultView";
import Bee from "@/note_office/icons/Bee.png";
import Blob from "@/note_office/icons/Blob.png";
import RedirectButton from "@/note_office/shared/RedirectButton";

const t = translator("note_office.views.referrals.new_view.");
const { Title, Text } = Typography;

const options = [
  {
    key: "discount",
  },
  {
    key: "upgrade",
  },
];

const NewView = ({ referralsData }) => {
  const [selected, setSelected] = useState("discount");
  const [view, setView] = useState("form");

  const { profile_url, referrals_url, bonus } = referralsData || {};

  const handleContinue = () => {
    if (selected === "discount") {
      const isSuccess = Math.random() < 0.5;
      setView(isSuccess ? "success" : "failure");
    } else {
      message.success(t("upgrade_flash"));
    }
  };

  const reset = () => {
    setView("form");
  };

  if (view === "success") {
    return (
      <ResultView
        image={Bee}
        className="wrapper__menu-layout"
        title={
          <span
            dangerouslySetInnerHTML={{
              __html: t("success_title.html", { bonus: referralsData.bonus }),
            }}
          />
        }
        buttons={[
          <RedirectButton key="main" type="primary" block className="button-base" url={profile_url}>
            {t("back_to_main")}
          </RedirectButton>,
        ]}
      />
    );
  }

  if (view === "failure") {
    return (
      <ResultView
        image={Blob}
        className="wrapper__menu-layout"
        title={t("failure_title")}
        buttons={[
          <RedirectButton key="retry" type="primary" block className="button-base" onClick={reset}>
            {t("try_again")}
          </RedirectButton>,
          <RedirectButton
            key="back"
            type="default"
            block
            className="button-base button-secondary"
            url={profile_url}
          >
            {t("back_to_main")}
          </RedirectButton>,
        ]}
      />
    );
  }

  return (
    <div className="wrapper wrapper__menu-layout overflow">
      <BackButton link={referrals_url} text={t("title")} />

      <div className="referrals-use__content">
        <Title level={5} className="referrals-use__title">
          {t("choose_usage_title")}
        </Title>
        <div className="referrals-use__container overflow">
          <div>
            {options.map((opt) => (
              <Card
                key={opt.key}
                className={classNames("referrals-use__option", {
                  "referrals-use__option--active": selected === opt.key,
                })}
                onClick={() => setSelected(opt.key)}
                bordered={false}
              >
                <div className="referrals-use__option-content">
                  <Checkbox
                    checked={selected === opt.key}
                    onChange={() => setSelected(opt.key)}
                    className="referrals-use__checkbox"
                  />
                  <div className="referrals-use__option-data">
                    <Text strong className="referrals-use__option-label">
                      {t(`option.${opt.key}`)}
                    </Text>
                    <div className="referrals-use__option-value">
                      {opt.value} {bonus} $
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
          <Button type="primary" block className="button-base" onClick={handleContinue}>
            {t("continue_button")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NewView;
